import { Box, Switch } from '@atgfr8/atg-ui-tailwind';
import {
  customerDetailsStore,
  updateCustomerDetailsState,
} from '@mobileStore/customer';
import { Group } from '@store/customers/customerDetails';
import { PencilIcon } from '@atgfr8/icons';
import {
  mobileIsAdmin,
  mobileIsManager,
  mobileIsSuperAdmin,
} from '@mobileUtils/roleUtils';
import { createMemo, createSignal, For, Show } from 'solid-js';
import SectionCard from '@mobileComponents/SectionCard';

import AssignCustomer from './AssignCustomer';
import AssignGroup from './AssignGroup';

const Ownership = () => {
  const [isAssignCustomerOpen, setIsAssignCustomerOpen] = createSignal(false);
  const [isAssignGroupOpen, setIsAssignGroupOpen] = createSignal(false);
  const [savedOfficeGroup, setSavedOfficeGroup] = createSignal<
    Group | undefined
  >(undefined);

  const notAllowedToClickPublic = createMemo(() => {
    return customerDetailsStore.assignOfficeGroup.some((x) => {
      return (
        x.officeId !== customerDetailsStore.customer.accountManagerOfficeId
      );
    });
  });

  return (
    <Box>
      <SectionCard title="OWNERSHIP" contentClass="p-1">
        <Box
          class={
            customerDetailsStore.customer.isPublic
              ? 'flex items-center bg-[#026EA1]! rounded-sm border-b border-t border-gray-400 p-2 m-2! text-[#FFFFFF]!'
              : 'flex items-center bg-[#ECEFF1]! rounded-sm py-2 px-4 m-2!'
          }
        >
          <Switch
            color="info"
            aria-label="isPublic-customer"
            checked={customerDetailsStore.customer.isPublic}
            size="sm"
            dataTestId="is-public-customer-switch"
            onChange={(checked) => {
              let newGroups: Group[] | undefined;

              if (!checked) {
                const officeGroup = customerDetailsStore.customer.groups.find(
                  (g) =>
                    g.name === 'The Office' &&
                    g.officeId ===
                      customerDetailsStore.customer.accountManagerOfficeId,
                );
                if (officeGroup) setSavedOfficeGroup(officeGroup);
                newGroups = customerDetailsStore.customer.groups.filter(
                  (g) =>
                    !(
                      g.name === 'The Office' &&
                      g.officeId ===
                        customerDetailsStore.customer.accountManagerOfficeId
                    ),
                );
              } else {
                const newOfficeGroup =
                  customerDetailsStore.assignOfficeGroup.find(
                    (x) =>
                      x.name === 'The Office' &&
                      x.officeId ===
                        customerDetailsStore.customer.accountManagerOfficeId,
                  ) ?? savedOfficeGroup();

                if (newOfficeGroup) {
                  newGroups = [
                    newOfficeGroup,
                    ...customerDetailsStore.customer.groups,
                  ];
                }
              }

              updateCustomerDetailsState({
                isPublic: checked,
                ...(newGroups !== undefined && { groups: newGroups }),
              });
            }}
            disabled={
              (!mobileIsManager() &&
                !mobileIsAdmin() &&
                !mobileIsSuperAdmin()) ||
              !customerDetailsStore.customer.isPublicEditable ||
              notAllowedToClickPublic()
            }
          />
          <span class="text-[14px]">
            {customerDetailsStore.customer.isPublic
              ? 'This customer can be seen by everyone in my office.'
              : 'This customer is private and can only be seen by the people assigned to it'}
          </span>
        </Box>
        <Box
          class="flex! items-center! p-2 text-[14px]! gap-2"
          onClick={() => setIsAssignCustomerOpen(true)}
        >
          <Box class="w-[90%]">
            <Box class="flex justify-between items-center mb-2">
              <span class="text-[14px] font-normal text-[#00000099]">
                Account Manager
              </span>
              <span class="text-[14px] font-medium">
                {customerDetailsStore.customer.accountManagerName}
              </span>
            </Box>
            <Box class="flex justify-between items-center">
              <span class="text-[14px] font-normal text-[#00000099]">
                Sales Manager
              </span>
              <span class="text-[14px] font-medium">
                {customerDetailsStore.customer.salesManagerName}
              </span>
            </Box>
          </Box>
          <Box class="w-[10%] flex justify-end items-center">
            <PencilIcon color="#026EA1" size={20} />
          </Box>
        </Box>
      </SectionCard>

      <SectionCard title="Assigned Groups">
        <Show
          when={customerDetailsStore.customer.groups.length > 0}
          fallback={
            <span class="p-2 font-light text-[14px]">
              -- No Groups Assigned --
            </span>
          }
        >
          <Box class="flex justify-between items-center p-2">
            <Box class="w-[90%]">
              <For each={customerDetailsStore.customer.groups}>
                {(g) => (
                  <Box class="flex justify-between items-center border-b w-full">
                    <span class="py-2 font-medium text-[14px]">
                      {`${g.name} (${g.office})`}
                    </span>{' '}
                  </Box>
                )}
              </For>
            </Box>
            <Box class="w-[10%] flex justify-end items-center">
              <PencilIcon
                color="#026EA1"
                size={20}
                onClick={() => setIsAssignGroupOpen(true)}
              />
            </Box>
          </Box>
        </Show>
      </SectionCard>

      <AssignCustomer
        isOpen={isAssignCustomerOpen()}
        onClose={() => setIsAssignCustomerOpen(false)}
      />
      <AssignGroup
        isOpen={isAssignGroupOpen()}
        onClose={() => setIsAssignGroupOpen(false)}
      />
    </Box>
  );
};

export default Ownership;
